export function make_question_survey(question) {
  let survey_obj = {pages: [{}]};
  survey_obj.pages[0] = {
    name: question.category,
    title: question.category,
    elements: [
      {
        "html": `<h5>${question.old_intern_number} / ${question.old_intern_number} ${question.topic.name}</h5><hr>`,
        "name": `topic-start ${question.topic.name}`,
        "type": "html",
        "help_text": question.topic.help_text,
        "topic_name": question.topic.name
      },
      {
        "name": `question${question.id}`,
        "type": question.question_type,
        "title": question.description,
        "indent": 1,
        "choices": [
          {
            "text": "Ja",
            "value": "ja"
          },
          {
            "text": "Nein",
            "value": "nein"
          },
          {
            "text": "Teilweise",
            "value": "teilweise"
          },
          {
            "text": "Nicht Zutreffend",
            "value": "nicht_zutreffend"
          }
        ],
        "help_text": question.help_text,
        "hasComment": "true",
        "commentText": "Bemerkung"
      },
    ]
  }
  return JSON.stringify(survey_obj)
}

export default make_question_survey
